// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file src/protos/learning_management/lms.liveQuiz.teacher.apis.proto (package geneo.lms.liveQuiz.teacher.apis, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { LiveQuizQuestionSession, LiveQuizSession } from "@protos/learning_management/lms.db_pb";
import { Question } from "@protos/content_management/content.db_pb";

/**
 * @generated from message geneo.lms.liveQuiz.teacher.apis.CreateLiveQuizSessionRequest
 */
export class CreateLiveQuizSessionRequest extends Message<CreateLiveQuizSessionRequest> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * Task.id (numeric) of the pre-authored MCQ/TF assessment — the same id the rest of the teacher app already carries through Redux after creation, not the string taskId
   *
   * @generated from field: int64 assessment_id = 2;
   */
  assessmentId = protoInt64.zero;

  /**
   * @generated from field: int64 school_class_section_id = 3;
   */
  schoolClassSectionId = protoInt64.zero;

  constructor(data?: PartialMessage<CreateLiveQuizSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.teacher.apis.CreateLiveQuizSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "school_class_section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateLiveQuizSessionRequest {
    return new CreateLiveQuizSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateLiveQuizSessionRequest {
    return new CreateLiveQuizSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateLiveQuizSessionRequest {
    return new CreateLiveQuizSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateLiveQuizSessionRequest | PlainMessage<CreateLiveQuizSessionRequest> | undefined, b: CreateLiveQuizSessionRequest | PlainMessage<CreateLiveQuizSessionRequest> | undefined): boolean {
    return proto3.util.equals(CreateLiveQuizSessionRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.teacher.apis.CreateLiveQuizSessionResponse
 */
export class CreateLiveQuizSessionResponse extends Message<CreateLiveQuizSessionResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: optional geneo.lms.db.LiveQuizSession live_quiz_session = 4;
   */
  liveQuizSession?: LiveQuizSession;

  /**
   * for signInWithCustomToken on the teacher client
   *
   * @generated from field: optional string firestore_custom_token = 5;
   */
  firestoreCustomToken?: string;

  /**
   * pre-materialized, ordered by sequence — the teacher client's advance-through-questions list
   *
   * @generated from field: repeated geneo.lms.db.LiveQuizQuestionSession question_sessions = 6;
   */
  questionSessions: LiveQuizQuestionSession[] = [];

  /**
   * full question content (text/options/correct answer), fetched once here — the teacher client matches by question_id against question_sessions rather than refetching per question
   *
   * @generated from field: repeated geneo.content.db.Question questions = 7;
   */
  questions: Question[] = [];

  /**
   * true if this reused an existing paused session for the same (teacher, assessment, section) instead of creating a new one — the client uses this to decide whether to land on the Lobby or jump straight back into the in-progress question
   *
   * @generated from field: bool resumed = 8;
   */
  resumed = false;

  /**
   * identifier required for subsequent session-control calls
   *
   * @generated from field: optional string session_instance_id = 9;
   */
  sessionInstanceId?: string;

  constructor(data?: PartialMessage<CreateLiveQuizSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.teacher.apis.CreateLiveQuizSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "live_quiz_session", kind: "message", T: LiveQuizSession, opt: true },
    { no: 5, name: "firestore_custom_token", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "question_sessions", kind: "message", T: LiveQuizQuestionSession, repeated: true },
    { no: 7, name: "questions", kind: "message", T: Question, repeated: true },
    { no: 8, name: "resumed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "session_instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateLiveQuizSessionResponse {
    return new CreateLiveQuizSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateLiveQuizSessionResponse {
    return new CreateLiveQuizSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateLiveQuizSessionResponse {
    return new CreateLiveQuizSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateLiveQuizSessionResponse | PlainMessage<CreateLiveQuizSessionResponse> | undefined, b: CreateLiveQuizSessionResponse | PlainMessage<CreateLiveQuizSessionResponse> | undefined): boolean {
    return proto3.util.equals(CreateLiveQuizSessionResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.teacher.apis.StartLiveQuizQuestionRequest
 */
export class StartLiveQuizQuestionRequest extends Message<StartLiveQuizQuestionRequest> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int64 live_quiz_session_id = 2;
   */
  liveQuizSessionId = protoInt64.zero;

  /**
   * @generated from field: int64 live_quiz_question_session_id = 3;
   */
  liveQuizQuestionSessionId = protoInt64.zero;

  /**
   * @generated from field: string session_instance_id = 4;
   */
  sessionInstanceId = "";

  constructor(data?: PartialMessage<StartLiveQuizQuestionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.teacher.apis.StartLiveQuizQuestionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "live_quiz_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "live_quiz_question_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "session_instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartLiveQuizQuestionRequest {
    return new StartLiveQuizQuestionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartLiveQuizQuestionRequest {
    return new StartLiveQuizQuestionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartLiveQuizQuestionRequest {
    return new StartLiveQuizQuestionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: StartLiveQuizQuestionRequest | PlainMessage<StartLiveQuizQuestionRequest> | undefined, b: StartLiveQuizQuestionRequest | PlainMessage<StartLiveQuizQuestionRequest> | undefined): boolean {
    return proto3.util.equals(StartLiveQuizQuestionRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.teacher.apis.StartLiveQuizQuestionResponse
 */
export class StartLiveQuizQuestionResponse extends Message<StartLiveQuizQuestionResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: optional geneo.lms.db.LiveQuizQuestionSession live_quiz_question_session = 4;
   */
  liveQuizQuestionSession?: LiveQuizQuestionSession;

  constructor(data?: PartialMessage<StartLiveQuizQuestionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.teacher.apis.StartLiveQuizQuestionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "live_quiz_question_session", kind: "message", T: LiveQuizQuestionSession, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StartLiveQuizQuestionResponse {
    return new StartLiveQuizQuestionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StartLiveQuizQuestionResponse {
    return new StartLiveQuizQuestionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StartLiveQuizQuestionResponse {
    return new StartLiveQuizQuestionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: StartLiveQuizQuestionResponse | PlainMessage<StartLiveQuizQuestionResponse> | undefined, b: StartLiveQuizQuestionResponse | PlainMessage<StartLiveQuizQuestionResponse> | undefined): boolean {
    return proto3.util.equals(StartLiveQuizQuestionResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.teacher.apis.EndLiveQuizQuestionRequest
 */
export class EndLiveQuizQuestionRequest extends Message<EndLiveQuizQuestionRequest> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int64 live_quiz_session_id = 2;
   */
  liveQuizSessionId = protoInt64.zero;

  /**
   * @generated from field: int64 live_quiz_question_session_id = 3;
   */
  liveQuizQuestionSessionId = protoInt64.zero;

  /**
   * @generated from field: string session_instance_id = 4;
   */
  sessionInstanceId = "";

  constructor(data?: PartialMessage<EndLiveQuizQuestionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.teacher.apis.EndLiveQuizQuestionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "live_quiz_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "live_quiz_question_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "session_instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EndLiveQuizQuestionRequest {
    return new EndLiveQuizQuestionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EndLiveQuizQuestionRequest {
    return new EndLiveQuizQuestionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EndLiveQuizQuestionRequest {
    return new EndLiveQuizQuestionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: EndLiveQuizQuestionRequest | PlainMessage<EndLiveQuizQuestionRequest> | undefined, b: EndLiveQuizQuestionRequest | PlainMessage<EndLiveQuizQuestionRequest> | undefined): boolean {
    return proto3.util.equals(EndLiveQuizQuestionRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.teacher.apis.EndLiveQuizQuestionResponse
 */
export class EndLiveQuizQuestionResponse extends Message<EndLiveQuizQuestionResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: optional geneo.lms.liveQuiz.teacher.apis.LiveQuizQuestionStats question_stats = 4;
   */
  questionStats?: LiveQuizQuestionStats;

  constructor(data?: PartialMessage<EndLiveQuizQuestionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.teacher.apis.EndLiveQuizQuestionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "question_stats", kind: "message", T: LiveQuizQuestionStats, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EndLiveQuizQuestionResponse {
    return new EndLiveQuizQuestionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EndLiveQuizQuestionResponse {
    return new EndLiveQuizQuestionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EndLiveQuizQuestionResponse {
    return new EndLiveQuizQuestionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: EndLiveQuizQuestionResponse | PlainMessage<EndLiveQuizQuestionResponse> | undefined, b: EndLiveQuizQuestionResponse | PlainMessage<EndLiveQuizQuestionResponse> | undefined): boolean {
    return proto3.util.equals(EndLiveQuizQuestionResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.teacher.apis.EndLiveQuizSessionRequest
 */
export class EndLiveQuizSessionRequest extends Message<EndLiveQuizSessionRequest> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int64 live_quiz_session_id = 2;
   */
  liveQuizSessionId = protoInt64.zero;

  /**
   * @generated from field: string session_instance_id = 3;
   */
  sessionInstanceId = "";

  constructor(data?: PartialMessage<EndLiveQuizSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.teacher.apis.EndLiveQuizSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "live_quiz_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "session_instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EndLiveQuizSessionRequest {
    return new EndLiveQuizSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EndLiveQuizSessionRequest {
    return new EndLiveQuizSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EndLiveQuizSessionRequest {
    return new EndLiveQuizSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: EndLiveQuizSessionRequest | PlainMessage<EndLiveQuizSessionRequest> | undefined, b: EndLiveQuizSessionRequest | PlainMessage<EndLiveQuizSessionRequest> | undefined): boolean {
    return proto3.util.equals(EndLiveQuizSessionRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.teacher.apis.EndLiveQuizSessionResponse
 */
export class EndLiveQuizSessionResponse extends Message<EndLiveQuizSessionResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  constructor(data?: PartialMessage<EndLiveQuizSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.teacher.apis.EndLiveQuizSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EndLiveQuizSessionResponse {
    return new EndLiveQuizSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EndLiveQuizSessionResponse {
    return new EndLiveQuizSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EndLiveQuizSessionResponse {
    return new EndLiveQuizSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: EndLiveQuizSessionResponse | PlainMessage<EndLiveQuizSessionResponse> | undefined, b: EndLiveQuizSessionResponse | PlainMessage<EndLiveQuizSessionResponse> | undefined): boolean {
    return proto3.util.equals(EndLiveQuizSessionResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.teacher.apis.GetLiveQuizRosterRequest
 */
export class GetLiveQuizRosterRequest extends Message<GetLiveQuizRosterRequest> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int64 live_quiz_session_id = 2;
   */
  liveQuizSessionId = protoInt64.zero;

  constructor(data?: PartialMessage<GetLiveQuizRosterRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.teacher.apis.GetLiveQuizRosterRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "live_quiz_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLiveQuizRosterRequest {
    return new GetLiveQuizRosterRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLiveQuizRosterRequest {
    return new GetLiveQuizRosterRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLiveQuizRosterRequest {
    return new GetLiveQuizRosterRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLiveQuizRosterRequest | PlainMessage<GetLiveQuizRosterRequest> | undefined, b: GetLiveQuizRosterRequest | PlainMessage<GetLiveQuizRosterRequest> | undefined): boolean {
    return proto3.util.equals(GetLiveQuizRosterRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.teacher.apis.GetLiveQuizRosterResponse
 */
export class GetLiveQuizRosterResponse extends Message<GetLiveQuizRosterResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: repeated geneo.lms.liveQuiz.teacher.apis.LiveQuizRosterEntry roster = 4;
   */
  roster: LiveQuizRosterEntry[] = [];

  constructor(data?: PartialMessage<GetLiveQuizRosterResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.teacher.apis.GetLiveQuizRosterResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "roster", kind: "message", T: LiveQuizRosterEntry, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLiveQuizRosterResponse {
    return new GetLiveQuizRosterResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLiveQuizRosterResponse {
    return new GetLiveQuizRosterResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLiveQuizRosterResponse {
    return new GetLiveQuizRosterResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetLiveQuizRosterResponse | PlainMessage<GetLiveQuizRosterResponse> | undefined, b: GetLiveQuizRosterResponse | PlainMessage<GetLiveQuizRosterResponse> | undefined): boolean {
    return proto3.util.equals(GetLiveQuizRosterResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.teacher.apis.LiveQuizRosterEntry
 */
export class LiveQuizRosterEntry extends Message<LiveQuizRosterEntry> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: optional string roll_number = 3;
   */
  rollNumber?: string;

  /**
   * @generated from field: optional string profile_pic_url = 4;
   */
  profilePicUrl?: string;

  /**
   * @generated from field: bool has_joined = 5;
   */
  hasJoined = false;

  constructor(data?: PartialMessage<LiveQuizRosterEntry>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.teacher.apis.LiveQuizRosterEntry";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "roll_number", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "profile_pic_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "has_joined", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LiveQuizRosterEntry {
    return new LiveQuizRosterEntry().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LiveQuizRosterEntry {
    return new LiveQuizRosterEntry().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LiveQuizRosterEntry {
    return new LiveQuizRosterEntry().fromJsonString(jsonString, options);
  }

  static equals(a: LiveQuizRosterEntry | PlainMessage<LiveQuizRosterEntry> | undefined, b: LiveQuizRosterEntry | PlainMessage<LiveQuizRosterEntry> | undefined): boolean {
    return proto3.util.equals(LiveQuizRosterEntry, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.teacher.apis.LiveQuizQuestionStats
 */
export class LiveQuizQuestionStats extends Message<LiveQuizQuestionStats> {
  /**
   * @generated from field: string question_id = 1;
   */
  questionId = "";

  /**
   * @generated from field: int64 live_quiz_question_session_id = 2;
   */
  liveQuizQuestionSessionId = protoInt64.zero;

  /**
   * @generated from field: int32 answered_count = 3;
   */
  answeredCount = 0;

  /**
   * @generated from field: int32 correct_count = 4;
   */
  correctCount = 0;

  /**
   * @generated from field: int32 incorrect_count = 5;
   */
  incorrectCount = 0;

  /**
   * @generated from field: int32 unanswered_count = 6;
   */
  unansweredCount = 0;

  /**
   * avg time taken among students who answered this question
   *
   * @generated from field: float average_time_in_sec = 7;
   */
  averageTimeInSec = 0;

  /**
   * % of answered students who got it correct — same "average score" the teacher-side indicator bar shows for Clicker
   *
   * @generated from field: int32 average_score_percent = 8;
   */
  averageScorePercent = 0;

  constructor(data?: PartialMessage<LiveQuizQuestionStats>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.teacher.apis.LiveQuizQuestionStats";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "question_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "live_quiz_question_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "answered_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "correct_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "incorrect_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "unanswered_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "average_time_in_sec", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "average_score_percent", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LiveQuizQuestionStats {
    return new LiveQuizQuestionStats().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LiveQuizQuestionStats {
    return new LiveQuizQuestionStats().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LiveQuizQuestionStats {
    return new LiveQuizQuestionStats().fromJsonString(jsonString, options);
  }

  static equals(a: LiveQuizQuestionStats | PlainMessage<LiveQuizQuestionStats> | undefined, b: LiveQuizQuestionStats | PlainMessage<LiveQuizQuestionStats> | undefined): boolean {
    return proto3.util.equals(LiveQuizQuestionStats, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.teacher.apis.GetLiveQuizSessionAnalyticsRequest
 */
export class GetLiveQuizSessionAnalyticsRequest extends Message<GetLiveQuizSessionAnalyticsRequest> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int64 live_quiz_session_id = 2;
   */
  liveQuizSessionId = protoInt64.zero;

  constructor(data?: PartialMessage<GetLiveQuizSessionAnalyticsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.teacher.apis.GetLiveQuizSessionAnalyticsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "live_quiz_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLiveQuizSessionAnalyticsRequest {
    return new GetLiveQuizSessionAnalyticsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLiveQuizSessionAnalyticsRequest {
    return new GetLiveQuizSessionAnalyticsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLiveQuizSessionAnalyticsRequest {
    return new GetLiveQuizSessionAnalyticsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLiveQuizSessionAnalyticsRequest | PlainMessage<GetLiveQuizSessionAnalyticsRequest> | undefined, b: GetLiveQuizSessionAnalyticsRequest | PlainMessage<GetLiveQuizSessionAnalyticsRequest> | undefined): boolean {
    return proto3.util.equals(GetLiveQuizSessionAnalyticsRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.teacher.apis.GetLiveQuizSessionAnalyticsResponse
 */
export class GetLiveQuizSessionAnalyticsResponse extends Message<GetLiveQuizSessionAnalyticsResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: optional geneo.lms.liveQuiz.teacher.apis.LiveQuizSessionAnalytics analytics = 4;
   */
  analytics?: LiveQuizSessionAnalytics;

  constructor(data?: PartialMessage<GetLiveQuizSessionAnalyticsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.teacher.apis.GetLiveQuizSessionAnalyticsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "analytics", kind: "message", T: LiveQuizSessionAnalytics, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLiveQuizSessionAnalyticsResponse {
    return new GetLiveQuizSessionAnalyticsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLiveQuizSessionAnalyticsResponse {
    return new GetLiveQuizSessionAnalyticsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLiveQuizSessionAnalyticsResponse {
    return new GetLiveQuizSessionAnalyticsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetLiveQuizSessionAnalyticsResponse | PlainMessage<GetLiveQuizSessionAnalyticsResponse> | undefined, b: GetLiveQuizSessionAnalyticsResponse | PlainMessage<GetLiveQuizSessionAnalyticsResponse> | undefined): boolean {
    return proto3.util.equals(GetLiveQuizSessionAnalyticsResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.teacher.apis.LiveQuizSessionAnalytics
 */
export class LiveQuizSessionAnalytics extends Message<LiveQuizSessionAnalytics> {
  /**
   * @generated from field: int64 live_quiz_session_id = 1;
   */
  liveQuizSessionId = protoInt64.zero;

  /**
   * @generated from field: int32 total_eligible_students = 2;
   */
  totalEligibleStudents = 0;

  /**
   * @generated from field: int32 joined_count = 3;
   */
  joinedCount = 0;

  /**
   * @generated from field: int32 total_questions = 4;
   */
  totalQuestions = 0;

  /**
   * @generated from field: float avg_score = 5;
   */
  avgScore = 0;

  /**
   * @generated from field: float max_score = 6;
   */
  maxScore = 0;

  /**
   * @generated from field: repeated geneo.lms.liveQuiz.teacher.apis.LiveQuizParticipantResult participant_results = 7;
   */
  participantResults: LiveQuizParticipantResult[] = [];

  /**
   * @generated from field: repeated geneo.lms.liveQuiz.teacher.apis.LiveQuizQuestionStats question_stats = 8;
   */
  questionStats: LiveQuizQuestionStats[] = [];

  constructor(data?: PartialMessage<LiveQuizSessionAnalytics>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.teacher.apis.LiveQuizSessionAnalytics";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "live_quiz_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "total_eligible_students", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "joined_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "total_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "avg_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "max_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "participant_results", kind: "message", T: LiveQuizParticipantResult, repeated: true },
    { no: 8, name: "question_stats", kind: "message", T: LiveQuizQuestionStats, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LiveQuizSessionAnalytics {
    return new LiveQuizSessionAnalytics().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LiveQuizSessionAnalytics {
    return new LiveQuizSessionAnalytics().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LiveQuizSessionAnalytics {
    return new LiveQuizSessionAnalytics().fromJsonString(jsonString, options);
  }

  static equals(a: LiveQuizSessionAnalytics | PlainMessage<LiveQuizSessionAnalytics> | undefined, b: LiveQuizSessionAnalytics | PlainMessage<LiveQuizSessionAnalytics> | undefined): boolean {
    return proto3.util.equals(LiveQuizSessionAnalytics, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.teacher.apis.LiveQuizParticipantResult
 */
export class LiveQuizParticipantResult extends Message<LiveQuizParticipantResult> {
  /**
   * @generated from field: int64 student_id = 1;
   */
  studentId = protoInt64.zero;

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: float score = 3;
   */
  score = 0;

  /**
   * @generated from field: float max_score = 4;
   */
  maxScore = 0;

  /**
   * @generated from field: int32 correct_count = 5;
   */
  correctCount = 0;

  /**
   * @generated from field: int32 total_questions = 6;
   */
  totalQuestions = 0;

  constructor(data?: PartialMessage<LiveQuizParticipantResult>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.teacher.apis.LiveQuizParticipantResult";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "student_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "max_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "correct_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "total_questions", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LiveQuizParticipantResult {
    return new LiveQuizParticipantResult().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LiveQuizParticipantResult {
    return new LiveQuizParticipantResult().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LiveQuizParticipantResult {
    return new LiveQuizParticipantResult().fromJsonString(jsonString, options);
  }

  static equals(a: LiveQuizParticipantResult | PlainMessage<LiveQuizParticipantResult> | undefined, b: LiveQuizParticipantResult | PlainMessage<LiveQuizParticipantResult> | undefined): boolean {
    return proto3.util.equals(LiveQuizParticipantResult, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.teacher.apis.GetPreviousLiveQuizSessionsRequest
 */
export class GetPreviousLiveQuizSessionsRequest extends Message<GetPreviousLiveQuizSessionsRequest> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int64 school_class_section_id = 2;
   */
  schoolClassSectionId = protoInt64.zero;

  /**
   * Task.id — scopes this to attempts of THIS assessment specifically, not every live quiz ever run in the section
   *
   * @generated from field: int64 assessment_id = 3;
   */
  assessmentId = protoInt64.zero;

  constructor(data?: PartialMessage<GetPreviousLiveQuizSessionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.teacher.apis.GetPreviousLiveQuizSessionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "school_class_section_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "assessment_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPreviousLiveQuizSessionsRequest {
    return new GetPreviousLiveQuizSessionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPreviousLiveQuizSessionsRequest {
    return new GetPreviousLiveQuizSessionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPreviousLiveQuizSessionsRequest {
    return new GetPreviousLiveQuizSessionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPreviousLiveQuizSessionsRequest | PlainMessage<GetPreviousLiveQuizSessionsRequest> | undefined, b: GetPreviousLiveQuizSessionsRequest | PlainMessage<GetPreviousLiveQuizSessionsRequest> | undefined): boolean {
    return proto3.util.equals(GetPreviousLiveQuizSessionsRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.teacher.apis.GetPreviousLiveQuizSessionsResponse
 */
export class GetPreviousLiveQuizSessionsResponse extends Message<GetPreviousLiveQuizSessionsResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  /**
   * @generated from field: repeated geneo.lms.db.LiveQuizSession sessions = 4;
   */
  sessions: LiveQuizSession[] = [];

  constructor(data?: PartialMessage<GetPreviousLiveQuizSessionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.teacher.apis.GetPreviousLiveQuizSessionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "sessions", kind: "message", T: LiveQuizSession, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPreviousLiveQuizSessionsResponse {
    return new GetPreviousLiveQuizSessionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPreviousLiveQuizSessionsResponse {
    return new GetPreviousLiveQuizSessionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPreviousLiveQuizSessionsResponse {
    return new GetPreviousLiveQuizSessionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPreviousLiveQuizSessionsResponse | PlainMessage<GetPreviousLiveQuizSessionsResponse> | undefined, b: GetPreviousLiveQuizSessionsResponse | PlainMessage<GetPreviousLiveQuizSessionsResponse> | undefined): boolean {
    return proto3.util.equals(GetPreviousLiveQuizSessionsResponse, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.teacher.apis.PauseLiveQuizSessionRequest
 */
export class PauseLiveQuizSessionRequest extends Message<PauseLiveQuizSessionRequest> {
  /**
   * @generated from field: int64 teacher_id = 1;
   */
  teacherId = protoInt64.zero;

  /**
   * @generated from field: int64 live_quiz_session_id = 2;
   */
  liveQuizSessionId = protoInt64.zero;

  /**
   * @generated from field: string session_instance_id = 3;
   */
  sessionInstanceId = "";

  constructor(data?: PartialMessage<PauseLiveQuizSessionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.teacher.apis.PauseLiveQuizSessionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "teacher_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "live_quiz_session_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "session_instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PauseLiveQuizSessionRequest {
    return new PauseLiveQuizSessionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PauseLiveQuizSessionRequest {
    return new PauseLiveQuizSessionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PauseLiveQuizSessionRequest {
    return new PauseLiveQuizSessionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PauseLiveQuizSessionRequest | PlainMessage<PauseLiveQuizSessionRequest> | undefined, b: PauseLiveQuizSessionRequest | PlainMessage<PauseLiveQuizSessionRequest> | undefined): boolean {
    return proto3.util.equals(PauseLiveQuizSessionRequest, a, b);
  }
}

/**
 * @generated from message geneo.lms.liveQuiz.teacher.apis.PauseLiveQuizSessionResponse
 */
export class PauseLiveQuizSessionResponse extends Message<PauseLiveQuizSessionResponse> {
  /**
   * @generated from field: int32 status = 1;
   */
  status = 0;

  /**
   * @generated from field: string code = 2;
   */
  code = "";

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  constructor(data?: PartialMessage<PauseLiveQuizSessionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "geneo.lms.liveQuiz.teacher.apis.PauseLiveQuizSessionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PauseLiveQuizSessionResponse {
    return new PauseLiveQuizSessionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PauseLiveQuizSessionResponse {
    return new PauseLiveQuizSessionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PauseLiveQuizSessionResponse {
    return new PauseLiveQuizSessionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PauseLiveQuizSessionResponse | PlainMessage<PauseLiveQuizSessionResponse> | undefined, b: PauseLiveQuizSessionResponse | PlainMessage<PauseLiveQuizSessionResponse> | undefined): boolean {
    return proto3.util.equals(PauseLiveQuizSessionResponse, a, b);
  }
}

